import { useState } from "react";
import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { Menu, X, Waves } from "lucide-react";

export default function Navigation() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <nav className="bg-white shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link href="/">
            <div className="flex items-center cursor-pointer">
              <Waves className="w-8 h-8 text-ocean-blue mr-2" />
              <div className="text-2xl font-playfair font-bold text-ocean-blue">
                South FL<span className="text-luxury-gold">Waterfront</span>
              </div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:block">
            <div className="flex items-center space-x-4">
              <Link href="/buy">
                <Button className="h-11 px-6 rounded-full bg-ocean-blue hover:bg-bright-blue text-white text-sm font-semibold shadow-md">
                  Buy
                </Button>
              </Link>
              <Link href="/sell">
                <Button variant="outline" className="h-11 px-6 rounded-full border-ocean-blue text-ocean-blue hover:bg-ocean-blue hover:text-white text-sm font-semibold shadow-md">
                  Sell
                </Button>
              </Link>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-deep-navy hover:text-ocean-blue"
            >
              {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </Button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden border-t border-gray-200">
            <div className="px-2 pt-3 pb-4 space-y-3 bg-white">
              <Link href="/buy">
                <Button className="w-full h-12 rounded-full bg-ocean-blue hover:bg-bright-blue text-white text-base font-semibold shadow-md">
                  Buy
                </Button>
              </Link>
              <Link href="/sell">
                <Button variant="outline" className="w-full h-12 rounded-full border-ocean-blue text-ocean-blue hover:bg-ocean-blue hover:text-white text-base font-semibold shadow-md">
                  Sell
                </Button>
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
